import { $ne as __ne, createQueryOperator } from "../../_predicates";
const $ne = createQueryOperator(__ne);
export {
  $ne
};
